const l = {
  name: "Lighthouse",
  dimensions: { width: 37, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 36.7 40" style="enable-background:new 0 0 36.7 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M16.9,0h3l3.5,4.7V10h2v2h-1.8l3.8,19.9V40h-18v-8.1L13.2,12h-1.8v-2h2V4.7L16.9,0z M15.4,10h6V5.3L18.9,2h-1
			l-2.5,3.3V10z M11.7,30.3L24,24.9l-0.8-4.4l-10.5,4.6L11.7,30.3z M13.2,22.7l9.6-4.2L21.9,14l-7.8,3.4L13.2,22.7z M14.6,15.1
			l6.9-3l0,0h-6.3L14.6,15.1z M24.4,27l-13,5.7v4.8l13.9-6.1L24.4,27z M25.4,38v-4.5L15.2,38H25.4z"/>
		<path class="st0" d="M36.7,1.9l-10,4L26,4.1l10-4L36.7,1.9z"/>
		<path class="st0" d="M36.7,12.1l-10-4L26,9.9l10,4L36.7,12.1z"/>
		<path class="st0" d="M0,12.1l10-4l0.7,1.9l-10,4L0,12.1z"/>
		<path class="st0" d="M0,1.9l10,4l0.7-1.9l-10-4L0,1.9z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as Lighthouse
};
